import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainScreenHeader from '../../common/Header/MainScreenHeader';
import './SettingsPage.scss';
import ProjectPhasesTab from './ProjectPhasesTab';
import UserManagementTab from './UserManagementTab';
import GenericVerticalTabs, { TabConfig } from '../../common/GenericVerticalTabs/GenericVerticalTabs';
import ResetSettingsTab from './ResetSettingsTab';
import CareerLevelRatesTab from './CareerLevelRatesTab';
import LedgerAccountsTab from './LedgerAccountsTab';
import FiscalYearsTab from './FiscalYearsTab';
import VatRatesTab from './VatRatesTab';
import DepreciationPeriodsTab from './DepreciationPeriodsTab';
import CompanyInfoTab from './CompanyInfoTab';
import BackupTab from './BackupTab';
import ReferenceNumbersTab from './ReferenceNumbersTab';
import RoleGuard from '../../common/RoleGuard';
import LanguageTab from './LanguageTab';
import BankAccountsTab from './BankAccountsTab';

const SettingsPage: React.FC = () => {
  const { t } = useTranslation('screens');
  const [activeTab, setActiveTab] = useState('phases');

  const tabs: TabConfig[] = [
    {
      key: 'company',
      label: t('settings.tabs.company'),
      content: <CompanyInfoTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'fiscalyears',
      label: t('settings.tabs.fiscalYears'),
      content: <FiscalYearsTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'bankaccounts',
      label: t('settings.tabs.bankAccounts'),
      content: <BankAccountsTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'ledgers',
      label: t('settings.tabs.ledgers'),
      content: <LedgerAccountsTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'vatrates',
      label: t('settings.tabs.vatRates'),
      content: <VatRatesTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'depreciationperiods',
      label: t('settings.tabs.depreciationPeriods'),
      content: <DepreciationPeriodsTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'referencenumbers',
      label: t('settings.tabs.referenceNumbers'),
      content: <ReferenceNumbersTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'phases',
      label: t('settings.tabs.phases'),
      content: <ProjectPhasesTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'careerlevels',
      label: t('settings.tabs.careerLevels'),
      content: <CareerLevelRatesTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'users',
      label: t('settings.tabs.users'),
      content: <UserManagementTab />,
      allowedRoles: 'Admin,Manager',
    },
    {
      key: 'language',
      label: t('settings.tabs.language'),
      content: <LanguageTab />,
    },
    {
      key: 'backup',
      label: t('settings.tabs.backup'),
      content: <BackupTab />,
      allowedRoles: 'Admin',
    },
    {
      key: 'reset',
      label: t('settings.tabs.reset'),
      content: <ResetSettingsTab />,
      allowedRoles: 'Admin,Manager',
    },
  ];

  return (
    <div className="settings-page fancy-details-bg">
      <RoleGuard roles="Admin,Manager" redirectOnDeny>
        <MainScreenHeader title={t('settings.title')} />
        <GenericVerticalTabs
          tabs={tabs}
          initialTabKey={activeTab}
          className="settings-vertical-tabs"
        />
      </RoleGuard>
    </div>
  );
};

export default SettingsPage;
